import { Box, Spinner } from '@chakra-ui/react';
import React from 'react';
import { UI } from 'src/apps/invest/common/shells/UI';

export const CheckoutCashflowLoadingPage: React.FC = () => {
  return (
    <UI>
      <Box w="full" alignItems="center" textAlign={'center'} p={10}>
        <Spinner color="blue.500" size="xl" />
      </Box>
    </UI>
  );
};
